module.exports = __webpack_public_path__ + "img/373-c94cb1.png";